const currentUrl = new URL(window.location.href);
// check URL whether is shared by APP 
if (currentUrl.searchParams.get('app_share')) {
  const pathname = currentUrl.pathname
  if (pathname.startsWith('/products/')){
    const handle = pathname.replace('/products/', '')
    const title = currentUrl.searchParams.get('app_title')
    openShareLinkInApp(handle, title)
  }
}

function openShareLinkInApp(handle, title) {
  var userAgent = navigator.userAgent
  var urlScheme;
  if (/android/i.test(userAgent)) {
    urlScheme = `wyze://wyzeapp:8080/v2?id=shop&handle=${handle}&title=${title}`; // replace the deep link for android
  } else if (/(iPhone|iPod|iPad);?/i.test(userAgent)) {
    urlScheme = `wyze://?id=shop&handle=${handle}&title=${title}`; // replace the deep link for ios
  }
  if (urlScheme) {
    window.location.href = urlScheme;
  }
}